//DropDown

import EventManager from '../Event/EventManager.js';

const defaultSettings = () => ({
    isExpanded:false,
    maxHeight:250,
    togglerClass:".dropdown-toggle"
});

export default class DropDown {

    constructor(element, userSettings = {}) {
        if (typeof element === 'string') {
            element = document.querySelector(element);
        }

        if (!element || !element.nodeName) {
            throw new Error('no element is specified to initialize DropDown');
        }

        this.element = element;

        this.settings = defaultSettings();
        for (const key in userSettings) {
            this.settings[key] = userSettings[key];
        }

        this.menu=null;
        this.toggle=null;

        this._open=false;

        this.isAlive = true;
        this.event = new EventManager();

        let f = this.element.querySelector(this.settings.togglerClass);
        if(f!==null){
            this.toggle=f;
            this.event.bind(this.toggle, 'click,touchstart', this.clicked.bind(this));
        }
        f = this.element.querySelector(".dropdown-menu");
        if(f!==null){
            this.menu=f;
            this._open=this.settings.isExpanded;
        }

        this.hclosing = this.closing.bind(this);
        this.initValue();
    }

    clicked() {
        this._open=!this._open;
        this.initValue();
    }

    initValue() {
        if ( this._open ){
            this.element.classList.add("show");
            this.menu.classList.add("show");
            let h=this.menu.scrollHeight;
            if(h>this.settings.maxHeight){
                h=this.settings.maxHeight;
                this.menu.style.height= h+'px';
            }
            this.registerHandlers();
        }else{
            this.element.classList.remove("show");
            this.menu.classList.remove("show");
            this.menu.style.height="";
            this.unregisterHandlers();
        }
    }

    registerHandlers( ) {
        document.addEventListener('mousedown', this.hclosing ,false);
        document.addEventListener('ontouchstart',this.hclosing ,false);
    };

    unregisterHandlers( ) {
        document.removeEventListener('mousedown', this.hclosing ,false);
        document.removeEventListener('ontouchstart', this.hclosing ,false);
    };

    closing(event) {
        if (this.menu.contains(event.target) || this.menu===event.target) {
            return false;
        }else{
            this._open=false;
            this.initValue();
        }
        return false;
    };

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.unregisterHandlers();
        this.event.unbindAll();

        this.isAlive = false;
    }
}
